import React from 'react';
import { HistogramDefaultEntry, HistogramEmptyEntry, Tooltip, TooltipArrow, TooltipCount, TooltipTime } from './HistogramEntry.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HistogramEntry = ({
  item,
  histogram,
  onClick
}) => {
  const barRoundingValue = 6;
  const barEmptyValue = barRoundingValue - 2;
  const getBarHeight = (value, maxValue) => {
    if (maxValue !== 0) {
      return Math.min(100, Math.ceil(100 * value / (maxValue * barRoundingValue)) * barRoundingValue);
    }
    return 0;
  };
  return item.count ? /*#__PURE__*/_jsx(HistogramDefaultEntry, {
    onClick: onClick,
    height: getBarHeight(item.count, histogram.maxValue),
    children: /*#__PURE__*/_jsxs(Tooltip, {
      children: [/*#__PURE__*/_jsx(TooltipArrow, {}), /*#__PURE__*/_jsx(TooltipCount, {
        children: item.count
      }), /*#__PURE__*/_jsx(TooltipTime, {
        children: histogram.formatTooltip(item.from)
      })]
    })
  }, item.from + item.to) : /*#__PURE__*/_jsx(HistogramEmptyEntry, {
    onClick: onClick,
    height: barEmptyValue
  }, item.from + item.to);
};